import { JSX } from 'react'

import { IconProps } from '../../icon'

const EdubookFavBook: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <g clipPath='url(#clip0_2236_195)'>
      <path d='M48 0H0V48H48V0Z' fill='url(#paint0_linear_2236_195)' />
      <path
        d='M2.07375 28.08L24 32.655L45.9262 28.08C45.9262 28.08 46.05 4.62188 23.8294 4.62188C1.60875 4.62188 2.07375 26.4394 2.07375 28.08Z'
        fill='url(#paint1_radial_2236_195)'
      />
      <path
        d='M24.7243 33.7521L7.35004 30.1256L6.63899 33.5321L24.0133 37.1587L24.7243 33.7521Z'
        fill='white'
      />
      <path
        d='M23.9871 37.1583L41.3614 33.5318L40.6503 30.1252L23.276 33.7517L23.9871 37.1583Z'
        fill='white'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_2236_195'
        x1='-3.87563'
        y1='-3.87563'
        x2='48.5925'
        y2='48.5925'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_2236_195'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(24.2231 33.6094) scale(22.5356 22.5356)'
      >
        <stop stopColor='white' stopOpacity='0.5' />
        <stop offset='0.27' stopColor='white' stopOpacity='0.35' />
        <stop offset='0.77' stopColor='white' stopOpacity='0.1' />
        <stop offset='1' stopColor='white' stopOpacity='0' />
      </radialGradient>
      <clipPath id='clip0_2236_195'>
        <rect width='48' height='48' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export default EdubookFavBook
